module.exports = __webpack_public_path__ + "static/media/innovonto-core.6ce7ff24.png";